import React from 'react'
import PropTypes from 'prop-types'
import Section from '../../Section'
import Interweave from 'interweave'
import { convertMdToHtml } from '..'

const KeyActorsAndCapabilities = ({ report: { reportContent } }) => (
  <Section title="Key Actors And Their Capabilities">
    <Interweave content={convertMdToHtml.makeHtml(reportContent.summary.keyActorsCapabilities)} />
  </Section>
)

KeyActorsAndCapabilities.propTypes = {
  report: PropTypes.object,
}

export default KeyActorsAndCapabilities
